import { useLanguage } from "../../i18n/LanguageContext";

export default function PracticeSubjectsPage({
  domains = [],
  loading,
  openDomain,
  goBack,
  styles,
}) {
  const { t } = useLanguage();

  return (
    <div style={styles.card}>
      <div style={styles.topBar}>
        <div>
          <div style={styles.quizPath}>
            {t("practice.practiceQuestions")}
          </div>

          <h2 style={styles.sectionTitle}>
            {t("practice.practiceBySubject")}
          </h2>

          <div
            style={{
              marginTop: "6px",
              color: "#6b7280",
            }}
          >
            {t("practice.practiceBySubjectDesc")}
          </div>
        </div>

        <button
          style={styles.secondaryButton}
          onClick={goBack}
        >
          {t("practice.back")}
        </button>
      </div>

      {loading ? (
        <div
          style={{
            ...styles.emptyBox,
            marginTop: "24px",
          }}
        >
          {t("practice.loadingSubjects")}
        </div>
      ) : domains.length === 0 ? (
        <div
          style={{
            ...styles.emptyBox,
            marginTop: "24px",
          }}
        >
          {t("practice.noSubjectsFound")}
        </div>
      ) : (
        <div
          style={{
            marginTop: "28px",
            display: "grid",
            gap: "12px",
          }}
        >
          {domains.map((domain) => (
            <button
              key={domain.id}
              style={styles.bigButton}
              onClick={() =>
                openDomain(domain)
              }
            >
              {domain.domain_name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}